<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h4>Info: {{ template.name }}</h4> <span class="fw-bold">Id: [{{ template.id }}]</span>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12">
    <div class="row">
        @if(isLoading)
        {
            <div class="d-flex flex-column justify-content-center align-items-center w-100">
                <div class="continuous-loader" role="status"></div>
                <h4 class="mt-2">{{ loadingText }}</h4>
            </div>
        }
        @else 
        {
            <div class="db-template-info">
            @if (template.dbAllowWrite)
            {
                <h5>Skriv:</h5>
                <hr>
                <span class="fw-bold">Ved oprettelse skal følgende felter angives:</span>
        
                @for (item of mandatoryFields; track $index)
                {
                    <div class="row">
                        <div class="col-12">
                            <span> '{{ item.name }}' af typen {{ item.dbTableitemInfo.defaultValueTypeNonSql }}  </span>
                        </div>
                    </div>
                }

                @if (defaultFields.length > 0)
                {
                    <div class="mt-2"></div>
                    <span class="fw-bold"> Følgende felter, hvis ikke angivet, sættes med defaultværdi:</span>
                    @for (item of defaultFields; track $index)
                    {
                        <div class="row">
                            <div class="col-12">
                                <span> '{{ item.name }}' af typen {{ item.dbTableitemInfo.defaultValueTypeNonSql }} værdi: {{ item.defaultValue }}  </span>
                            </div>
                        </div>
                    }
                }
                
                @if (keyFields.length > 0)
                {
                    <div class="mt-2"></div>
                    <span class="fw-bold">Ved opdatering fremsøges poster via følgende nøglefelter:</span>
                    @for (item of keyFields; track $index)
                    {
                        <div class="row">
                            <div class="col-12">
                                <span> '{{ item.name }}' af typen {{ item.dbTableitemInfo.defaultValueTypeNonSql }}  </span>
                            </div>
                        </div>
                    }

                    <div class="mt-2"></div>
                    <span class="fw-bold">Følgende felter kan opdateres:</span>
                    @for (item of updateFields; track $index)
                    {
                        <div class="row">
                            <div class="col-12">
                                <span> '{{ item.name }}' af typen {{ item.dbTableitemInfo.defaultValueTypeNonSql }}  </span>
                            </div>
                        </div>
                    }
                }
                @else {
                    <div class="mt-4"></div>
                    <span class="fw-bold">NB! Der er ingen nøglefelter defineret! Alle indkomne poster bliver betragtet som nye!</span>
                }                    
            }
            @if (template.dbAllowRead)
            {
                <div class="mt-4"></div>
                <h5>Læs:</h5>
                <hr>
                <div class="mt-2"></div>

                <span class="fw-bold">Følgende felter kan der forspørges på / læses:</span>
                @for (item of readFields; track $index)
                {
                    <div class="row">
                        <div class="col-12">
                            <span> '{{ item.name }}' af typen {{ item.dbTableitemInfo.defaultValueTypeNonSql }} {{ item.dbTableitemInfo.isKey ? '[Nøglefelt]' : ''}} </span>
                        </div>
                    </div>
                }
            }

            @if (template.dbAllowDelete)
            {
                <div class="mt-4"></div>
                <h5>Slet:</h5>
                <hr>
                <span class="fw-bold">Følgende felter kan angives for at slette en eller flere poster:</span>
                @for (item of readFields; track $index)
                {
                    <div class="row">
                        <div class="col-12">
                            <span> '{{ item.name }}' af typen {{ item.dbTableitemInfo.defaultValueTypeNonSql }} {{ item.dbTableitemInfo.isKey ? '[Nøglefelt]' : ''}} </span>
                        </div>
                    </div>
                }
            }
        </div>
        }
    </div>
</div>
<div class="modal-footer bg-transparent">
    <button class="btn btn-danger float-end" (click)="activeModal.dismiss('luk')">Luk</button>
</div>
